export const DISCOUNT_SCOPE_LABELS = {
    order: 'The whole order',
    item: 'A single item',
    both: 'Either',
};
//# sourceMappingURL=catalog.js.map